import React from 'react'

export const LostTicketModal = ({
  confirmHandler,
  closeModalHandler
}) => {
  return (
    <>
      <h2 className="swal2-title">
        Are you sure you want to regenerate barcode for the ticket?
      </h2>
      <div className="swal2-content">
        <div id="swal2-content">It’s impossible to take step back then</div>
      </div>
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button className="swal2-confirm swal2-styled" onClick={confirmHandler}>
          Confirm
        </button>
      </div>
    </>
  )
}
